import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import Tabs from '../../../components/Tabs';
import props from '../../../lib/contentLayoutProps/admissions/layoutProps';

const tabs = ['親子班', '幼稚園／幼兒園', '小學'];

/* eslint-disable react/prop-types */
export default class extends React.Component {
  state = {
    tab: 0,
  };

  render() {
    const { tab } = this.state;

    return (
      <ContentLayout {...props} locale="zh" pageKey="entry-requirements">
        <h1>入學資格</h1>
        <Tabs tabs={tabs} onChangeTab={index => this.setState({ tab: index })} />
        {tab === 0 && (
          <React.Fragment>
            <p>本園是根據該學年的學額來決定取錄學生與否。所有學生必須已獲得由香港入境事務處發出的入境／居留證明。</p>
            <p>每年的八月中為新年度的開課日期，我們會按小朋友的年齡安排其入讀適合的級別。</p>

            <h3>入讀京斯敦國際學校</h3>
            <p>
              就讀京斯敦國際幼稚園的學生將會比非本校生優先獲得京斯敦國際學校的小一學位。小一學位將會最先分配予一歲班開始入讀本校的學生。
            </p>

            <h3>上課時間</h3>
            <table>
              <tbody>
                <tr>
                  <td>上午班</td>
                  <td>8:45 a.m. 至 11:00 a.m.</td>
                </tr>
                <tr>
                  <td>下午班</td>
                  <td>1:30 p.m. 至 03:45 p.m.</td>
                </tr>
              </tbody>
            </table>

            <h3>師生比例</h3>
            <table>
              <tbody>
                <tr>
                  <td>親子班</td>
                  <td>2:16</td>
                </tr>
              </tbody>
            </table>
          </React.Fragment>
        )}
        {tab === 1 && (
          <React.Fragment>
            <p>
              本園是根據該學年的學額來決定取錄學生與否，而每年的八月中為新年度的開課日期，我們會按小朋友的年齡安排其入讀適合的級別。
            </p>
            <p>所有學生必須已獲得由香港入境事務處發出的入境／居留證明。</p>

            <table>
              <thead>
                <tr>
                  <th>班別</th>
                  <th>於十二月三十一日前出生</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>兩歲班</td>
                  <td>兩歲</td>
                </tr>
                <tr>
                  <td>三歲班</td>
                  <td>三歲</td>
                </tr>
                <tr>
                  <td>四歲班</td>
                  <td>四歲</td>
                </tr>
                <tr>
                  <td>五歲班</td>
                  <td>五歲</td>
                </tr>
              </tbody>
            </table>

            <h3>入讀京斯敦國際學校</h3>
            <p>
              就讀京斯敦國際幼稚園的學生將會比非本校生優先獲得京斯敦國際學校的小一學位。小一學位將會最先分配予一歲班開始入讀本校的學生。
            </p>

            <h3>上課時間</h3>
            <table>
              <tbody>
                <tr>
                  <td>上午班</td>
                  <td>8:45 a.m. 至 11:45 a.m.</td>
                </tr>
                <tr>
                  <td>下午班</td>
                  <td>1:30 p.m. 至 04:30 p.m.</td>
                </tr>
              </tbody>
            </table>

            <h3>師生比例</h3>
            <table>
              <tbody>
                <tr>
                  <td>兩歲班</td>
                  <td>2:16</td>
                </tr>
                <tr>
                  <td>三歲班</td>
                  <td>2:18</td>
                </tr>
                <tr>
                  <td>四歲班</td>
                  <td>2:20</td>
                </tr>
                <tr>
                  <td>五歲班</td>
                  <td>4:5</td>
                </tr>
              </tbody>
            </table>
          </React.Fragment>
        )}
        {tab === 2 && (
          <React.Fragment>
            <p>本校是根據學年的學額來決定取錄學生與否，而學生須懂英語和普通話，校方會按照以下年齡編配所讀之級別。</p>
            <p>所有學生必須已獲得由香港入境事務處發出的入境／居留證明。</p>

            <table>
              <thead>
                <tr>
                  <th>班別</th>
                  <th>於十二月三十一日前出生</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>一年級</td>
                  <td>五歲</td>
                </tr>
                <tr>
                  <td>二年級</td>
                  <td>六歲</td>
                </tr>
                <tr>
                  <td>三年級</td>
                  <td>七歲</td>
                </tr>
                <tr>
                  <td>四年級</td>
                  <td>八歲</td>
                </tr>
                <tr>
                  <td>五年級</td>
                  <td>九歲</td>
                </tr>
                <tr>
                  <td>六年級</td>
                  <td>十歲</td>
                </tr>
              </tbody>
            </table>

            <h3>上課時間</h3>
            <p>
              上課時間為早上八時四十五分至下午三時十五分(星期一至星期五)。家長須為孩子預備健康午餐，以及兩份健康茶點。
            </p>
          </React.Fragment>
        )}
      </ContentLayout>
    );
  }
}
